import styles from "./pageError.module.scss";
import PropTypes from 'prop-types';
import Image from "../../atoms/image/image";

const PageError = ({ className, heading, description, primaryLabel, secondaryLabel, imgUrl, handlePrimaryClick, handleSecondaryClick }) => {
    return <section className={`${styles.wrapper} ${className}`}>
        <div className="container">
            <div className="row">
                <div className="col-12 text-center px-0">
                    {imgUrl && <Image
                        className={styles["error-symbol"]}
                        img_path={imgUrl}
                    />}
                    <h1 className={styles.heading}>{heading}</h1>
                    <p className={styles.description}
                    dangerouslySetInnerHTML={{
                        __html: description,
                      }} />
                </div>
                <div className={`col-12 text-center px-0 ${styles.actions}`}>
                    {primaryLabel && <button onClick={handlePrimaryClick} className={`btn btn-danger ${styles.primary}`}>
                        {primaryLabel}
                    </button>}
                    {secondaryLabel && <button onClick={handleSecondaryClick} className={`${styles.secondary}`}>
                        {secondaryLabel}
                    </button>}
                </div>
            </div>
        </div>
    </section>
}

PageError.propTypes = {
    className: PropTypes.string,
    heading: PropTypes.string,
    description: PropTypes.string,
    primaryLabel: PropTypes.string,
    secondaryLabel: PropTypes.string,
    handlePrimaryClick: PropTypes.func,
    handleSecondaryClick: PropTypes.func,
    imgUrl: PropTypes.string,
};

PageError.defaultProps = {
    className: "error-page",
    handlePrimaryClick: () => { },
    handleSecondaryClick: () => { },
};

export default PageError;
